import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';
import { socket } from '../../../../index'
import config from "../../../../config/config";
import { download } from "../../../sc-utilities/download.utils";
import * as snackbarActions from "../../../sc-utilities/snackbar/store/snackbarActions";
import { TRANSPORT_COLLI } from "../../../sc-utilities/snackbar/store/actionTypes";
import snackbarStore from "../../../../snackbarStore";

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'palettes/transportColli',
    pluginName: 'PALETTE',
    entityName: 'TRANSPORT_COLLI',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// const updateDownloadProgress = progress => {
//     return {
//         type: 'DOWNLOAD|DOWNLOAD_PROGRESS',
//         downloadProgress: progress.downloadProgress,
//         maxSize: progress.maxSize,
//         currentSize: progress.currentSize,
//         snackBar: progress.snackBar,
//         data: progress,
//         name: progress.name
//     };
// };


// Fetch transport colli action creators
export const fetchTransportColliInit = () => {
    return crudActions.fetchInit();
};
export const fetchTransportColliStart = () => {
    return crudActions.fetchStart();
};
export const fetchTransportColliSuccess = () => {
    return crudActions.fetchSuccess();
};
export const fetchTransportColliFail = () => {
    return crudActions.fetchFail();
};
export const fetchTransportColliCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchTransportColliStart());
        try {
            let countRes = await rest.post("palettes/transportColli/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchTransportColliSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchTransportColliFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch transport collies."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchTransportColliFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch transport collies."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchTransportColli = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchTransportColliStart());
        try {
            let listRes = await rest.post("palettes/transportColli/list", { ...filterData, doesHaveProducts: true });
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchTransportColliSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchTransportColliFail());
            return []

        } catch (error) {
            dispatch(fetchTransportColliFail());
            return []

        }
    }
}
export const fetchTransportCollies = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post("/palettes/transportColli/list", { listAll: true, ...params });
            if (res.data && res.data.succeeded) {
                let transportCollies = [];
                for (var transportColli of res.data.result.data) {
                    transportCollies.push({
                        value: transportColli.TransportColliID,
                        displayValue: `${transportColli.Name} (${transportColli.TransportColliInventoryID})`
                    });
                }
                return transportCollies;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list transport collies "}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};


// Load TransportColli action creators
export const loadTransportColliInit = () => {
    return crudActions.loadInit();
};
export const loadTransportColliStart = () => {
    return crudActions.loadStart();
};
export const loadTransportColliSuccess = loadedTransportColli => {
    return crudActions.loadSuccess(loadedTransportColli);
};
export const loadTransportColliFail = error => {
    return crudActions.loadFail(error);
};
export const loadTransportColli = (loadParams, options = {}) => {
    return async dispatch => {
        await crudActions.load(dispatch, loadParams, options);
    };
};

// Create transport colli action creators
export const createTransportColliInit = () => {
    return crudActions.createInit();
};
export const createTransportColliStart = () => {
    return crudActions.createStart();
};
export const createTransportColliSuccess = createdTransportColli => {
    return crudActions.createSuccess(createdTransportColli);
};
export const createTransportColliFail = error => {
    return crudActions.createFail(error);
};

export const createTransportColli = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createTransportColliStart());
        try {
            let res = await rest.post('/palettes/transportColli/create', params);
            if (res.data && res.data.succeeded) {
                dispatch(createTransportColliSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully created transport colli.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createTransportColliFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create transport colli."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create transport colli."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createTransportColliFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Edit transport colli  action creators
export const editTransportColliInit = () => {
    return crudActions.editInit();
};
export const editTransportColliStart = () => {
    return crudActions.editStart();
};
export const editTransportColliSuccess = editedTransportColli => {
    return crudActions.editSuccess(editedTransportColli);
};
export const editTransportColliFail = error => {
    return crudActions.editFail(error);
};

export const editTransportColli = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editTransportColliStart());
        try {
            let res = await rest.post('/palettes/transportColli/save', params);
            if (res.data && res.data.succeeded) {
                dispatch(editTransportColliSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated transport colli.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editTransportColliFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit transport colli."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit transport colli."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editTransportColliFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete transport colli action creators
export const bulkDeleteTransportColliesInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteTransportColliesStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteTransportColliesSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteTransportColliesFail = error => {
    return crudActions.bulkDeleteFail(error);
};


export const bulkDeleteTransportCollies = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteTransportColliesStart());
        try {
            let res = await rest.post('/palettes/transportColli/bulk_delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteTransportColliesSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully delete transport colli.`,
                    options: {
                        variant: 'success'
                    }
                });
                return true;
            }
            dispatch(bulkDeleteTransportColliesFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot delete transport colli."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot delete transport colli."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteTransportColliesFail(error));
            snackActions.snackBar({
                message: `${error.message ? error.message : "Cannot delete transport colli."}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// custom functions
export const listOrders = (data, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/palettes/order/list', { listAll: true, ...data }, options);
            if (res.data && res.data.succeeded) {
                const orders = [];
                for (var order of res.data.result.data) {
                    orders.push({ value: order.OrderID, displayValue: order.Name });
                }
                return orders;
            }
            else {
                if (res && res.canceled) {
                    return [];
                }
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}

export const generateReports = (transportColli, translations) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            transportColli['SocketID'] = socket.id.split('#')[1];
            let res = await rest.post('/report/create-collection', transportColli);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: translations['create_collection_started'] || `Create collection started.`,
                    options: {
                        variant: 'success'
                    }
                });
                const redisTopic = res.data.result.data.RedisTopic;
                socket.on(redisTopic, async msg => {
                    const { Status, ErasureReportID, RedisTopic } = msg;
                    const { TransportColliInventoryID, Generated, ToGenerate, Message } = msg;
                    snackbarStore.dispatch(snackbarActions.showCollection({ type: TRANSPORT_COLLI, collection: { TransportColliInventoryID, Generated, ToGenerate } }));
                    if (Status === 'error') {
                        socket.off(RedisTopic);
                        snackbarStore.dispatch(snackbarActions.hideCollection({ type: TRANSPORT_COLLI, collection: { TransportColliInventoryID, Generated, ToGenerate } }));
                        return snackActions.snackBar({
                            message: Message || translations['error_create_collection'] || `Error: Create collection failed. Please contact administrator.`,
                            options: {
                                variant: 'error'
                            }
                        });
                    }

                    if (Status === 'generated') {
                        const objUrl = `${config.backend_domain}:${config.backend_port}/report/download?ReportID=${ErasureReportID}&ActiveCustomerID=${transportColli.ActiveCustomerID}`;
                        socket.off(RedisTopic);
                        snackbarStore.dispatch(snackbarActions.hideCollection({ type: TRANSPORT_COLLI, collection: { TransportColliInventoryID, Generated, ToGenerate } }));
                        await download(objUrl);
                        snackActions.snackBar({
                            message: translations['create_collection_finished'] || `Create collection finished.`,
                            options: {
                                variant: 'success'
                            }
                        });
                    }

                });
            } else {
                snackActions.snackBar({
                    message: translations['error_create_collection'] || `Error: Create collection failed. Please contact administrator.`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: translations['error_create_collection'] || `Error: Create collection failed. Please contact administrator.`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    };
}

export const unpairedBulkExternalTransportColliAction = () => {
    return ({
        type: 'EXTERNAL_TRANSPORT',
    });
}

export const unpairedBulkExternalTransportColli = (externalIDs, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/palettes/transportColli/bulk_unpair', { TransportColliExternalInfoIDs: externalIDs.data, ActiveCustomerID: externalIDs.ActiveCustomerID }, options);
            dispatch(unpairedBulkExternalTransportColliAction());
            if (res.data && res.data.succeeded) {
                return res.data.status === 200;
            }
            else {
                if (res && res.canceled) {
                    return false;
                }
                return false;

            }
        }
        catch (error) {
            return false;
        }
    };
}

export const unpairedExternalTransportColli = (externalID, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/palettes/transportColli/unpair', { TransportColliExternalInfoID: externalID.data, ActiveCustomerID: externalID.ActiveCustomerID }, options);
            dispatch(unpairedBulkExternalTransportColliAction());

            if (res.data && res.data.succeeded) {
                return res.data.status === 200;
            }
            else {
                if (res && res.canceled) {
                    return false;
                }
                return false;
            }
        } catch (error) {
            return false;
        }
    };
}

export const galleryTrue = (data) => {
    return ({
        type: 'GALLERY_OPEN_TRANSPORT',
        gallery: data
    });
}

export const ClearState = (data) => {
    return ({
        type: 'CLEAR_STATE',
    });
}
